import styled from 'styled-components'
import { breakpoints } from '@awaze/design-system.utils.react'

export const StyledPropertyCardNewDesign = styled.div`
  background: #ffffff;
  box-shadow:
    0 0px 0.5px 0 rgba(0, 0, 0, 0.1),
    0 0px 4px 0 rgba(0, 0, 0, 0.2);

  border-radius: 4px;

  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 0;
  transition: all 0.2s ease-out;
  will-change: transform, box-shadow;
  outline-color: ${({ theme }) => theme.ColorGrey200};

  &:hover,
  &:focus-within {
    box-shadow:
      0 0px 0.5px 0 rgba(0, 0, 0, 0.1),
      0 0px 16px 2px rgba(0, 0, 0, 0.15);
    outline: 1px ${({ theme }) => theme.ColorGrey200} solid;
  }

  @media only screen and (min-width: ${breakpoints[0]}px) {
    display: grid;
    grid-template-columns: 220px 1.8fr auto 1fr;
    grid-template-rows: 1fr auto auto;

    > div:last-child {
      grid-column: 2 / span 3;
      grid-row: 3;
    }
  }
  @media only screen and (min-width: ${breakpoints[1]}px) {
    grid-template-columns: 300px 1.8fr auto 1fr;
  }

  .mobile-ksp {
    @media only screen and (min-width: ${breakpoints[0]}px) {
      display: none;
    }
  } 

    .tablet-ksp {
    @media only screen and (max-width: ${breakpoints[0]}px) {
      display: none;
    }
  } 
}

`

export const StyledCustomerMessagingBadge = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
`

export const StyledGradeAndRatingContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.75rem 1.5rem;
  flex-grow: 1 !important;
  justify-content: start;
`

export const StyledUrgencyMessaging = styled.div`
  grid-row: 2;
  grid-column: 1 / span 2;
  width: 100%;
  display: flex;

  > p {
    flex-grow: 1;
    margin: 0;
    padding: 0;
    width: 100%;
    background-color: ${({ theme }) => theme.ColorStatusConstructive25};
    font-size: ${({ theme }) => theme.FontTextText100MidFontSize}px;
    color: ${({ theme }) => theme.ColorStatusConstructive600};
    padding: 4px 8px;
    font-weight: 600;

    @media only screen and (min-width: ${breakpoints[0]}px) {
      width: auto;
      flex-grow: 0;
    }
  }
`

export const StyledGradeIcon = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const StyledStarsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  grid-column: 2;
`

export const StyledPropertySpecs = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  list-style-type: none;
  padding: 0;
  margin: 0;
`

export const StyledIndividualPropertySpec = styled.li`
  flex: 1 1 auto;
  text-align: center;
`

export const StyledCarouselAnchor = styled.a`
  position: relative;
  z-index: 1;
`

export const StyledContentAnchor = styled.a`
  position: relative;
  z-index: 1;
  text-decoration: none;
  color: inherit;
  padding: 1rem;
  border: none;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    display: grid;
    grid-column: 2 / span 3;
    grid-row: 1 / span 2;
    grid-template-columns: subgrid;
    grid-template-rows: subgrid;

    > div:first-child {
      grid-column: 3;
      grid-row: 1 / span 2;
    }

    > div:nth-child(2) {
      grid-column: 1;
      grid-row: 1;
    }

    > ul {
      grid-column: 1;
      grid-row: 2;
    }

    > div[aria-orientation='vertical'] {
      grid-row: auto / span 2;
    }

    > hr[aria-orientation='horizontal'] {
      display: none;
    }
  }
`

export const StyledCarouselFloatingElements = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`
export const StyledCarouselContainer = styled.div`
  position: relative;
  z-index: 1;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    grid-row: 1 / span 3;
    grid-column: 1;
  }
`

export const StyledKSPItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;

  p {
    margin: 0;
    padding: 0;
    height: auto;
    line-height: 0.875rem;
  }
`

export const StyledPricingContainer = styled.div<{
  direction: string
}>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  justify-content: space-between;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`

export const StyledPrice = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.25rem;
`

export const StyledPriceInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.25rem;
`
